<div class="app">
    <la-menu role="banner" />
    <la-toast-container aria-live="polite" aria-atomic="true" />

    <main class="main-content mt-5 mb-5">
        <div class="container">
            <router-outlet></router-outlet>
        </div>
    </main>
    <la-footer role="contentinfo" />
</div>
